import {navigationService} from 'Application/services/NavigationService';

/**
 * A custom hook that provides access to the setCurrentSection function from the navigation service.
 * This hook serves as a React-friendly interface for updating the current section in the navigation state.
 * It follows the single responsibility principle by exposing only the section-setting functionality.
 *
 * @returns A function that sets the current section in the navigation service.
 *
 * @example
 * ```tsx
 * const {setCurrentSection} = useSetCurrentSection();
 *
 * // Set the current section to 'home'
 * setCurrentSection('home');
 *
 * // Use in a component
 * const NavigationButton = ({ sectionId }) => {
 *   const {setCurrentSection} = useSetCurrentSection();
 *
 *   return (
 *     <button onClick={() => setCurrentSection(sectionId)}>
 *       Go to {sectionId}
 *     </button>
 *   );
 * };
 * ```
 */
export const useSetCurrentSection = () => ({setCurrentSection: navigationService.setCurrentSection});